import styled from 'libs/styled';

const Defs = styled('defs')``;

export default Defs;
